import { Tabs, TabsItem } from '$uikit';
import React, { FC, useState } from 'react';
import { FiltersProps } from '$core/Profile/Filters/Filters.interface';
import { useProfileInfo, useTranslator, useUserInfo } from '$hooks';
import { ListOfButtonSelect } from '$uikit/ListOfButtonSelect/ListOfButtonSelect';
import { useListOfButtonSelect } from '$core/Profile/Filters/hooks/useListOfButtonSelect';
import { useDispatch, useSelector } from 'react-redux';
import { totalSelector } from '$store/posts';
import { PostsFilter } from '$store/profile/interface';
import { profileActions } from '$store/profile';
import { RootState } from '$store/rootReducer';
import { listReelsByIdSelector } from '$store/reels';

export const Filters: FC<FiltersProps> = ({
  activeTab,
  handleTabChange,
  profileId,
  setFilter,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const t = useTranslator();
  const { postsCount, reelsCount } = useProfileInfo(profileId);
  const user = useUserInfo(profileId);
  const isModel = user && user?.verified === 2;
  const isAddFilter = isModel && activeTab === 'all';
  const total = useSelector(totalSelector);
  const listOfButtonSelect = useListOfButtonSelect(total);
  const dispatch = useDispatch();
  const reels = useSelector((state: RootState) =>
    listReelsByIdSelector(state, profileId),
  );

  const onSelect = (value) => {
    const filter: PostsFilter =
      value === 'all'
        ? {}
        : {
            [value]: true,
          };

    setFilter(filter);

    dispatch(
      profileActions.loadFilteredPosts({
        ownerId: profileId,
        filter,
      }),
    );
  };

  return (
    <>
      <Tabs selected={activeTab} onChange={handleTabChange}>
        <TabsItem value="all" counter={postsCount}>
          {t('profile_tab_all')}
        </TabsItem>
        {!isModel && <TabsItem value="replies">{t('profile_tab_replies')}</TabsItem>}
        {isModel && (
          <TabsItem value="clips" counter={reelsCount}>
            {t('navbar_reels')}
          </TabsItem>
        )}
      </Tabs>
      {isAddFilter && (
        <ListOfButtonSelect
          setSelect={onSelect}
          setSelectedIndex={setSelectedIndex}
          selectedIndex={selectedIndex}
          data={listOfButtonSelect}
        />
      )}
    </>
  );
};
